<template>
  <div class="rechargeResult">
    <div v-if="success">
      <div class="success-icon">
        <van-icon name="checked" color="#18B75D" size="49" />
        <br />
        订单支付成功
      </div>
      <div class="content">
        <van-cell-group>
          <van-cell title="订单支付完成,请为顾客准备商品吧~~~~"  />
          <van-button type="default" to="cardDetail">返回储值卡</van-button>
        </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/css/rechargeResult.less";
import {} from "@/api/card";

export default {
  name: "PayResult",
  data() {
    return {
      success: true,
      showPopup: false,
      payResult: "",
    };
  },
  components: {},
  created() {
    this.loadComments();
  },
  methods: {
    loadComments() {
      let s = sessionStorage.getItem("shopInfo");
      let c = sessionStorage.getItem("cardInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
      this.cardInfo = c ? JSON.parse(c) : "";

      let r = sessionStorage.getItem("orderResult");
      this.payResult = r ? JSON.parse(r) : "";
    },
  },
};
</script>


